import CallToActionSection from './CallToActionSection';
export default function HelpSection() {
  return (

    <CallToActionSection
      gradient="linear-gradient(to right, #2f2f2f, #1a1a1a)"
      title="¿Tienes alguna duda o necesitas asesoría?"
      description={`Contáctanos y da el primer paso hacia el <strong> éxito de tu familia, empresa y patrimonio. <strong/>`}
      buttonText="Agenda una cita"
      buttonLink="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2eVA-xB-1w0bULc68zTMQ5dWAK4AP9Ow9P6r6QQl4DFZkqdrRENaPyWxRyLbAtrmocL908Fkfl"
      image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1748391663/ebm/108510_1_pxceur.png"
      target = "_blank"
    />

  );
}